import * as Headless from '@sail/theme-headless';
import {css, theme} from '../theme';

export const Button = theme(Headless.Button, [
  css({
    '--button-background-color': css.value('transparent'),

    fontWeight: 'semibold',
    position: css.value('relative'),
    zIndex: css.value(0),
    backgroundColor: css.value('var(--button-background-color)'),
    borderRadius: css.value('$space.75'),
    transition: css.value('background-color 0.24s, box-shadow 0.24s'),
    height: css.value('fit-content'),
    width: css.value('fit-content'),

    [Headless.ActionVariants.disabled.true]: {
      cursor: css.value('default'),

      '&:after': {
        display: css.value('block'),
        content: css.value('""'),
        position: css.value('absolute'),
        top: css.value('-1px'),
        left: css.value('-1px'),
        bottom: css.value('-1px'),
        right: css.value('-1px'),
        borderRadius: css.value('$space.75'),
        zIndex: css.value(1),
        backgroundColor: css.value('$color.neutral0'),
        pointerEvents: css.value('none'),
        opacity: css.value(0.5),
      },
    },

    [Headless.ButtonVariants.size.small]: {
      // TODO: make a font-size and line-height scale?
      fontSize: css.value('12px'),
      lineHeight: css.value('16px'),
      minHeight: css.value('24px'),
      paddingX: 'small',
      paddingY: 'xsmall',
      gap: css.value('$space.50'),
    },

    [Headless.ButtonVariants.size.medium]: {
      fontSize: css.value('14px'),
      lineHeight: css.value('20px'),
      minHeight: css.value('28px'),
      paddingX: 100,
      paddingY: 50,
      gap: css.value('$space.75'),
    },

    [Headless.ButtonVariants.size.large]: {
      fontSize: css.value('16px'),
      lineHeight: css.value('24px'),
      minHeight: css.value('40px'),
      paddingX: 'medium',
      paddingY: 'small',
      gap: css.value('$space.100'),
    },

    [Headless.ButtonVariants.type.primary]: {
      '--button-background-color': css.value('$color.brand500'),
      keyline: css.value('$color.brand500'),
      color: css.value('$color.neutral0'),
      topShadow: css.value('0px 1px 1px 0px rgba(20, 19, 78, 0.16)'),
      '&:active': {
        '--button-background-color': css.value('$color.brand600'),
        topShadow: css.value('0px -1px 1px 0px rgba(20, 19, 78, 0.16)'),
        keyline: css.value('color.brand700'),
        color: css.value('$color.brand100'),
      },
      '&:hover': {
        keyline: css.value('$color.brand700'),
      },
    },

    [Headless.ButtonVariants.type.secondary]: {
      '--button-background-color': css.value('$color.neutral0'),
      keyline: css.value('$color.neutral150'),
      topShadow: css.value('0px 1px 1px 0px rgba(16, 17, 26, 0.16)'),
      color: 'primary',
      '& > svg': {
        color: css.value('$iconColor.primary'),
      },
      '&:active': {
        '--button-background-color': css.value('$color.neutral50'),
        topShadow: css.value('0px -1px 1px 0px rgba(16, 17, 26, 0.16)'),
        color: css.value('$color.neutral600'),
      },
      '&:hover': {
        keyline: css.value('$color.neutral300'),
      },
    },

    [Headless.ButtonVariants.type.destructive]: {
      '--button-background-color': css.value('$color.critical500'),
      keyline: css.value('$color.critical500'),
      color: css.value('$color.neutral0'),
      topShadow: css.value('0px 1px 1px 0px rgba(62, 2, 26, 0.16)'),
      '&:active': {
        '--button-background-color': css.value('$color.critical600'),
        topShadow: css.value('0px -1px 1px 0px rgba(62, 2, 26, 0.16)'),
        keyline: css.value('$color.critical700'),
        color: css.value('$color.critical100'),
      },
      '&:hover': {
        keyline: css.value('$color.critical700'),
      },
    },
  }),
]);
